import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Modal from "../Modal";
import ProductAuth from "../ProductAuth";

export default function Header() {
  const [showModal, setShowModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // navbar collapse state
  const navRef = useRef(null);

  // close navbar if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (isOpen && navRef.current && !navRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <>
      <header id="site-header" className="header">
        {/* 🔹 Top bar */}
        <div className="header-top">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-4 col-md-6 d-flex align-items-center">
                <h6 className="mb-0">Olymipian Laboratories</h6>
              </div>
              <div className="col-lg-8 col-md-6 d-flex align-items-center justify-content-end">
                <div className="topbar-link">
                  <ul className="list-inline">
                    <li>
                      <i className="flaticon flaticon-envelope"></i>
                      <a href="mailto:info@olympianlaboratories.com">
                        info@olympianlaboratories.com
                      </a>
                    </li>
                    <li>
                      <i className="bi bi-clock-fill"></i>
                      <span>Mon - Fri 10:00 to 6:00</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 🔹 Main Navbar */}
        <div id="header-wrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col mx-4">
                <nav
                  className="navbar navbar-expand-xl w-100"
                  ref={navRef}
                >
                  {/* Brand Logo */}
                  <Link className="navbar-brand logo me-0" to="/">
                    <img
                      className="img-fluid"
                      src="assets/images/Olympia_IMG/olpmpians LOGO.png"
                      alt="logo"
                      style={{ maxHeight: "65px", width: "auto" }}
                    />
                  </Link>

                  {/* Collapse Toggle Button */}
                  <button
                    className={`navbar-toggler ht-toggler ms-auto ${
                      isOpen ? "open" : ""
                    }`}
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <svg width="100" height="100" viewBox="0 0 100 100">
                      <path
                        className="line line1"
                        d="M 20,29.000046 H 80"
                      ></path>
                      <path className="line line2" d="M 20,50 H 80"></path>
                      <path
                        className="line line3"
                        d="M 20,70.999954 H 80"
                      ></path>
                    </svg>
                  </button>

                  {/* Collapse Menu */}
                  <div
                    className={`collapse navbar-collapse ${
                      isOpen ? "show" : ""
                    }`}
                    id="navbarNav"
                  >
                    <ul className="nav navbar-nav">
                      <li className="nav-item">
                        <Link
                          className="nav-link active"
                          to="/"
                          onClick={() => setIsOpen(false)}
                        >
                          HOME
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to="/aboutus"
                          onClick={() => setIsOpen(false)}
                        >
                          ABOUT US
                        </Link>
                      </li>
                      <li className="nav-item dropdown">
                        <Link
                          className="nav-link"
                          to="/products"
                          onClick={() => setIsOpen(false)}
                        >
                          PRODUCTS
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link"
                          to="/contact"
                          onClick={() => setIsOpen(false)}
                        >
                          CONTACT
                        </Link>
                      </li>

                      {/* Mobile-only Verify Button */}
                      <li className="nav-item d-xl-none mt-3">
                        <button
                          className="themeht-btn primary-btn w-100"
                          onClick={() => {
                            setShowModal(true);
                            setIsOpen(false);
                          }}
                        >
                          Verify Product
                        </button>
                      </li>
                    </ul>
                  </div>

                  {/* Desktop-only Verify Button */}
                  <div className="header-right d-none d-xl-flex align-items-center justify-content-end">
                    <button
                      className="themeht-btn primary-btn"
                      onClick={() => setShowModal(true)}
                    >
                      Verify Product
                    </button>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* 🔹 Modal with ProductAuth inside */}
      <Modal show={showModal} onClose={() => setShowModal(false)}>
        <ProductAuth />
      </Modal>
    </>
  );
}
